<div id="sys-management" class="overlay-inner-wrapper overlay-fullscreen">
  <header class="header-2">
    <div class="branding">
      <span class="title">{{ 'Systemverwaltung' | mrTranslate }}</span>
    </div>
    <div class="header-actions">
      @if (isLoading() || isDetailViewLoading()) {
        <span class="clr-align-self-center margin-10-r"><clr-spinner clrMedium clrInverse /></span>
      }
      <a href="javascript://" class="nav-link nav-icon" (click)="close()"><cds-icon shape="times" /></a>
    </div>
  </header>

  <div clrModalHost class="h-60">
    <clr-side-panel
      #navPanel
      class="left-side-panel"
      [clrSidePanelPosition]="'left'"
      [clrSidePanelBackdrop]="false"
      [clrSidePanelPinnable]="true"
      [clrSidePanelOpen]="isNavPanelOpen()"
      (clrSidePanelOpenChange)="isNavPanelOpen.set($event)">
      <h3 class="side-panel-title">{{ 'Aktion' | mrTranslate }}</h3>
      <div class="side-panel-body h-100">
        <clr-accordion class="w-100-p">
          @for (group of actionsTree; track group.groupTitle) {
            @let title = group.groupTitle;
            @let actions = group.actions;
            <clr-accordion-panel>
              <clr-accordion-title>{{ title | mrTranslate }}</clr-accordion-title>
              <clr-accordion-content *clrIfExpanded>
                @for (block of actions; track $index) {
                  @if (block) {
                    @for (action of block; track $index) {
                      @if (action) {
                        <button class="btn" (click)="setView(action)">
                          {{ titleMap[action] | mrTranslate }}
                        </button>
                      }
                    }
                    @if (!$last) {
                      <hr />
                    }
                  }
                }
              </clr-accordion-content>
            </clr-accordion-panel>
          }
        </clr-accordion>
      </div>
    </clr-side-panel>

    <div class="side-panel-toggle left">
      @if (isNavPanelOpen()) {
        <button type="button" class="btn btn-icon btn-info" (click)="isNavPanelOpen.set(false)">
          <cds-icon shape="angle-double" direction="left" size="32" />
        </button>
      } @else {
        <button type="button" class="btn btn-icon btn-info" (click)="isNavPanelOpen.set(true)">
          <cds-icon shape="angle-double" direction="right" size="32" />
        </button>
      }
    </div>
    <div class="clr-row nxm padding-24-l padding-12-tb h-100 w-100-p">
      <div
        class="clr-col h-100 scroll-y d-f col width100 clr-align-items-center"
        [style.max-width.%]="
          !showdetailview || hidedetailview ? 100
          : split50 ? 50
          : 66
        ">
        @if (tblLeft()) {
          <div class="clr-row nxm clr-align-self-stretch clr-justify-content-between margin-10-t">
            <div class="btn-group btn-sm">
              @if (isMultiSelect()) {
                <app-all-selected-btn [(selected)]="selectedtabellenLM" [all]="filterStore.filteredRows()" />
              }
              <button
                class="btn btn-primary nm"
                style="min-width: 40px"
                (click)="filterStore.deleteAllFilters()"
                [disabled]="filterStore.filteredRows().length == tblLeft().rows.length">
                <clr-tooltip>
                  <cds-icon clrTooltipTrigger shape="filter-off" />
                  <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                    {{ 'Alle Filter zurücksetzen' | mrTranslate }}
                  </clr-tooltip-content>
                </clr-tooltip>
              </button>
            </div>
            @if (tblRight()) {
              <button
                class="btn btn-primary btn-sm nm"
                style="min-width: 40px"
                (click)="filterStore_II.deleteAllFilters()"
                [disabled]="filterStore_II.filteredRows().length == tblRight().rows.length">
                <clr-tooltip>
                  <cds-icon clrTooltipTrigger shape="filter-off" />
                  <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                    {{ 'Alle Filter zurücksetzen' | mrTranslate }} {{ 'rechts' | mrTranslate }}
                  </clr-tooltip-content>
                </clr-tooltip>
              </button>
            }
          </div>
        }
        @switch (action()) {
          @case ('Gruppenberechtigungen') {
            <div class="flex-1-1-0 clr-align-self-stretch" style="min-height: 200px">
              <app-gruppen-zuordnung [mode]="'objekte'" />
            </div>
          }
          @case ('Auftragsgruppenberechtigungen') {
            <div class="flex-1-1-0 clr-align-self-stretch" style="min-height: 200px">
              <app-gruppen-zuordnung [mode]="'aufträge'" />
            </div>
          }
          @case ('createBackupDatabase') {
            <div class="center-wrapper">
              @if (isDBBackup()) {
                <ng-container *ngTemplateOutlet="centered" />
              }
            </div>
          }
          @case ('inspRestore') {
            <div class="flex-1-1-0 clr-align-self-stretch" style="min-height: 200px">
              <ng-container *ngTemplateOutlet="tableLeft" />
            </div>
            <button class="btn" (click)="startAction()" [disabled]="!selectedtabellenL()">
              {{ 'Prüfung wiederherstellen' | mrTranslate }}
            </button>
          }
          @case ('inspFullDelete') {
            <div class="flex-1-1-0 clr-align-self-stretch" style="min-height: 200px">
              <ng-container *ngTemplateOutlet="tableLeft" />
            </div>
            <button class="btn" (click)="startAction()" [disabled]="!selectedtabellenL()">
              {{ 'Prüfung löschen' | mrTranslate }}
            </button>
          }
          @case ('masterRestore') {
            <div class="flex-1-1-0 clr-align-self-stretch" style="min-height: 200px">
              <ng-container *ngTemplateOutlet="tableLeft" />
            </div>
            <button class="btn" (click)="startAction()" [disabled]="!selectedtabellenL()">
              {{ 'Stammdaten wiederherstellen' | mrTranslate }}
            </button>
          }
          @case ('masterDelete') {
            <div class="flex-1-1-0 clr-align-self-stretch" style="min-height: 200px">
              <ng-container *ngTemplateOutlet="tableLeftMulti" />
            </div>
            <button class="btn" (click)="startAction()" [disabled]="!selectedtabellenLM().length">
              {{ 'Stammdaten löschen' | mrTranslate }}
            </button>
          }
          @case ('masterDeleteMultiple') {
            <div class="flex-1-1-0 clr-align-self-stretch" style="min-height: 200px">
              <ng-container *ngTemplateOutlet="tableLeftMulti" />
            </div>
            <button class="btn" (click)="startAction()" [disabled]="!selectedtabellenLM().length">
              {{ 'Stammdaten löschen' | mrTranslate }}
            </button>
          }
          @case ('masterUnlock') {
            <div class="flex-1-1-0 clr-align-self-stretch" style="min-height: 200px">
              <ng-container *ngTemplateOutlet="tableLeftMulti" />
            </div>
            <div class="clr-row nxm clr-justify-content-center clr-align-items-center">
              <clr-toggle-container clrInline class="nym margin-10-r">
                <clr-toggle-wrapper>
                  <label>{{ 'sxmrep-Tabelle stattdessen komplett leeren' | mrTranslate }}</label>
                  <input type="checkbox" clrToggle [(ngModel)]="sxmrepDelete" [ngModelOptions]="{ standalone: true }" />
                </clr-toggle-wrapper>
              </clr-toggle-container>
              <button class="btn" (click)="startAction()" [disabled]="!(sxmrepDelete || selectedtabellenLM().length)">
                {{ 'Stammdaten entsperren' | mrTranslate }}
              </button>
            </div>
          }
          @case ('masterArchive') {
            <div class="flex-1-1-0 clr-align-self-stretch" style="min-height: 200px">
              <ng-container *ngTemplateOutlet="tableLeft" />
            </div>
            <button class="btn" (click)="startAction()" [disabled]="!selectedtabellenL()">
              {{ 'Objekt wiederherstellen' | mrTranslate }}
            </button>
          }
          @case ('masterCopy') {
            <div class="flex-1-1-0 clr-align-self-stretch" style="min-height: 200px">
              <ng-container *ngTemplateOutlet="tableLeft" />
            </div>
            <form
              clrForm
              (ngSubmit)="f.valid && startAction()"
              #f="ngForm"
              class="clr-row nxm width100 clr-justify-content-center clr-align-items-baseline"
              [clrLabelSize]="5"
              [clrLayout]="'horizontal'">
              <clr-input-container class="nym margin-12-r">
                <label class="clr-required-mark">{{ 'Bezeichnung' | mrTranslate }}:</label>
                <input type="text" clrInput name="bez" [(ngModel)]="copyBezeichnung" required pattern="^.*\S+.*$" />
                <clr-control-error *clrIfError>
                  {{ 'Erforderlich' | mrTranslate }}
                </clr-control-error>
              </clr-input-container>
              <button class="btn" [disabled]="!selectedtabellenL()">
                {{ 'Objekt kopieren' | mrTranslate }}
              </button>
            </form>
          }
          @case ('radiusbvbimport') {
            <table class="table clr-col-10">
              <thead>
                <tr>
                  <th>{{ 'Datei' | mrTranslate }}</th>
                  <th>{{ 'Referenz zum Gleis' | mrTranslate }}</th>
                  <th>{{ 'MR.pro Feld' | mrTranslate }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div class="inline-cell">
                      <a class="clickable" (click)="openFileDialog('radius')">
                        <cds-icon shape="folder-open" size="22" />
                        {{ 'Radius-Datei auswählen: ' | mrTranslate }} {{ selRadiusFileName() }}
                      </a>
                    </div>
                    @if (mappingErrors['radius'] && dbfFieldsRadius().length > 0) {
                      <div class="clr-error">
                        {{ mappingErrors['radius'][0] }}
                      </div>
                    }
                  </td>

                  <td>
                    @if (dbfFieldsRadius().length > 0) {
                      <select clrSelect [(ngModel)]="selRadiusReferenz">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>
                        @for (field of dbfFieldsRadius(); track field.name) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    {{ 'Trassierung' | mrTranslate }}
                  </td>
                  <td>
                    @if (dbfFieldsRadius().length > 0) {
                      <a class="clickable" (click)="showInfoTable('radius')">
                        <cds-icon shape="info-standard" size="22" />
                      </a>
                    }
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <div class="btn-group">
              <button class="btn" (click)="startImportBVBRadius()" [disabled]="!hasSelectionRadiusReferenz()">
                {{ ' Radius importieren' | mrTranslate }}
              </button>
            </div>

            <input
              type="file"
              #fileInputSHP
              id="fileInputSHP"
              accept=".dbf"
              name="fileInputSHP"
              style="display: none"
              (change)="onShpFileSelected($event)" />
          }
          @case ('railbvbimport') {
            <table class="table clr-col-10 nxp">
              <thead>
                <tr>
                  <th>{{ 'Datei' | mrTranslate }}</th>
                  <th>{{ 'Referenz zum Gleis' | mrTranslate }}</th>
                  <th>{{ 'Bezeichnung' | mrTranslate }}</th>
                  <th>{{ 'Startmeter' | mrTranslate }}</th>
                  <th>{{ 'Endmeter' | mrTranslate }}</th>
                  <th>{{ 'MR.pro Feld' | mrTranslate }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div class="inline-cell">
                      <a class="clickable" (click)="openFileDialog('schienenform')">
                        <cds-icon shape="folder-open" size="22" />
                        {{ 'Schienenform auswählen: ' | mrTranslate }} {{ selSchienenformFileName() }}
                      </a>
                    </div>
                    @if (mappingErrors['schienenform'] && dbfFieldsSchiene().length > 0) {
                      <div class="clr-error">
                        {{ mappingErrors['schienenform'][0] }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsSchiene().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.schienenform.referenzZumGleis"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsSchiene(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsSchiene().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.schienenform.bezeichnung"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsSchiene(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsSchiene().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.schienenform.startmeter"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsSchiene(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsSchiene().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.schienenform.endmeter"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsSchiene(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>

                  <td>
                    {{ 'Schienenform' | mrTranslate }}
                  </td>

                  <td>
                    @if (dbfFieldsSchiene().length > 0) {
                      <a class="clickable" (click)="showInfoTable('schienenform')">
                        <cds-icon shape="info-standard" size="22" />
                      </a>
                    }
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="inline-cell">
                      <a class="clickable" (click)="openFileDialog('befestigung')">
                        <cds-icon shape="folder-open" size="22" />
                        {{ 'Befestigung auswählen: ' | mrTranslate }} {{ selBefestigungFileName() }}
                      </a>
                    </div>
                    @if (mappingErrors['befestigung'] && dbfFieldsBefestigung().length > 0) {
                      <div class="clr-error">
                        {{ mappingErrors['befestigung'][0] }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsBefestigung().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.befestigung.referenzZumGleis"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsBefestigung(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsBefestigung().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.befestigung.bezeichnung"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsBefestigung(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsBefestigung().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.befestigung.startmeter"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsBefestigung(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsBefestigung().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.befestigung.endmeter"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsBefestigung(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    {{ 'Befestigung' | mrTranslate }}
                  </td>
                  <td>
                    @if (dbfFieldsBefestigung().length > 0) {
                      <a class="clickable" (click)="showInfoTable('befestigung')">
                        <cds-icon shape="info-standard" size="22" />
                      </a>
                    }
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="inline-cell">
                      <a class="clickable" (click)="openFileDialog('unterbau')">
                        <cds-icon shape="folder-open" size="22" />
                        {{ 'Unterbau auswählen: ' | mrTranslate }} {{ selUnterbauFileName() }}
                      </a>
                    </div>
                    @if (mappingErrors['unterbau'] && dbfFieldsUnterbau().length > 0) {
                      <div class="clr-error">
                        {{ mappingErrors['unterbau'][0] }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsUnterbau().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.unterbau.referenzZumGleis"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsUnterbau(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsUnterbau().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.unterbau.bezeichnung"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsUnterbau(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsUnterbau().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.unterbau.startmeter"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsUnterbau(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsUnterbau().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.unterbau.endmeter"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsUnterbau(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    {{ 'Schwellenart' | mrTranslate }}
                  </td>
                  <td>
                    @if (dbfFieldsUnterbau().length > 0) {
                      <a class="clickable" (click)="showInfoTable('unterbau')">
                        <cds-icon shape="info-standard" size="22" />
                      </a>
                    }
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="inline-cell">
                      <a class="clickable" (click)="openFileDialog('eindeckung')">
                        <cds-icon shape="folder-open" size="22" />
                        {{ 'Eindeckung auswählen: ' | mrTranslate }} {{ selEindeckungFileName() }}
                      </a>
                    </div>
                    @if (mappingErrors['eindeckung'] && dbfFieldsEindeckung().length > 0) {
                      <div class="clr-error">
                        {{ mappingErrors['eindeckung'][0] }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsEindeckung().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.eindeckung.referenzZumGleis"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsEindeckung(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsEindeckung().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.eindeckung.bezeichnung"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsEindeckung(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsEindeckung().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.eindeckung.startmeter"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsEindeckung(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsEindeckung().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.eindeckung.endmeter"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsEindeckung(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    {{ 'Eindeckung' | mrTranslate }}
                  </td>
                  <td>
                    @if (dbfFieldsEindeckung().length > 0) {
                      <a class="clickable" (click)="showInfoTable('eindeckung')">
                        <cds-icon shape="info-standard" size="22" />
                      </a>
                    }
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="inline-cell">
                      <a class="clickable" (click)="openFileDialog('einbaujahrgleis')">
                        <cds-icon shape="folder-open" size="22" />
                        {{ 'Einbaujahr Gleis auswählen: ' | mrTranslate }} {{ selEinbaujahrGleisFileName() }}
                      </a>
                    </div>
                  </td>
                  <td>
                    @if (dbfFieldsEinbaujahrGleis().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.einbaujahrgleis.referenzZumGleis"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsEinbaujahrGleis(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsEinbaujahrGleis().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.einbaujahrgleis.bezeichnung"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsEinbaujahrGleis(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsEinbaujahrGleis().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.einbaujahrgleis.startmeter"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsEinbaujahrGleis(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsEinbaujahrGleis().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.einbaujahrgleis.endmeter"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsEinbaujahrGleis(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    {{ 'Einbaujahr' | mrTranslate }}
                  </td>
                  <td>
                    @if (dbfFieldsEinbaujahrGleis().length > 0) {
                      <a class="clickable" (click)="showInfoTable('einbaujahrgleis')">
                        <cds-icon shape="info-standard" size="22" />
                      </a>
                    }
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="inline-cell">
                      <a class="clickable" (click)="openFileDialog('einbaujahrunterbau')">
                        <cds-icon shape="folder-open" size="22" />
                        {{ 'Einbaujahr Unterbau auswählen: ' | mrTranslate }} {{ selEinbaujahrUnterbauFileName() }}
                      </a>
                    </div>
                    @if (mappingErrors['einbaujahrunterbau'] && dbfFieldsEinbaujahrUnterbau().length > 0) {
                      <div class="clr-error">
                        {{ mappingErrors['einbaujahrunterbau'][0] }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsEinbaujahrUnterbau().length > 0) {
                      <select clrSelect [(ngModel)]="dbfMappings.einbaujahrunterbau.referenzZumGleis">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsEinbaujahrUnterbau(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsEinbaujahrUnterbau().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.einbaujahrunterbau.bezeichnung"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsEinbaujahrUnterbau(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsEinbaujahrUnterbau().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.einbaujahrunterbau.startmeter"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsEinbaujahrUnterbau(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsEinbaujahrUnterbau().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.einbaujahrunterbau.endmeter"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsEinbaujahrUnterbau(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    {{ 'Schwellenjahr' | mrTranslate }}
                  </td>
                  <td>
                    @if (dbfFieldsEinbaujahrUnterbau().length > 0) {
                      <a class="clickable" (click)="showInfoTable('einbaujahrUnterbau')">
                        <cds-icon shape="info-standard" size="22" />
                      </a>
                    }
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="inline-cell">
                      <a class="clickable" (click)="openFileDialog('daemmung')">
                        <cds-icon shape="folder-open" size="22" />
                        {{ 'Dämmung auswählen: ' | mrTranslate }} {{ selDaemmungFileName() }}
                      </a>
                    </div>
                  </td>
                  <td>
                    @if (dbfFieldsDaemmung().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.daemmung.referenzZumGleis"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsDaemmung(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsDaemmung().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.daemmung.bezeichnung"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsDaemmung(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsDaemmung().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.daemmung.startmeter"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsDaemmung(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsDaemmung().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.daemmung.endmeter"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsDaemmung(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    {{ 'Dämmung' | mrTranslate }}
                  </td>
                  <td>
                    @if (dbfFieldsDaemmung().length > 0) {
                      <a class="clickable" (click)="showInfoTable('daemmung')">
                        <cds-icon shape="info-standard" size="22" />
                      </a>
                    }
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="inline-cell">
                      <a class="clickable" (click)="openFileDialog('schienenguete')">
                        <cds-icon shape="folder-open" size="22" />
                        {{ 'Schienengüte auswählen: ' | mrTranslate }} {{ selSchienengueteFileName() }}
                      </a>
                    </div>
                    @if (mappingErrors['schienenguete'] && dbfFieldsSchienenguete().length > 0) {
                      <div class="clr-error">
                        {{ mappingErrors['schienenguete'][0] }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsSchienenguete().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.schienenguete.referenzZumGleis"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsSchienenguete(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsSchienenguete().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.schienenguete.bezeichnung"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsSchienenguete(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsSchienenguete().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.schienenguete.startmeter"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsSchienenguete(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    @if (dbfFieldsSchienenguete().length > 0) {
                      <select
                        clrSelect
                        [(ngModel)]="dbfMappings.schienenguete.endmeter"
                        (ngModelChange)="validateMappings()">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFieldsSchienenguete(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                    }
                  </td>
                  <td>
                    {{ 'Schienengüte' | mrTranslate }}
                  </td>
                  <td>
                    @if (dbfFieldsSchienenguete().length > 0) {
                      <a class="clickable" (click)="showInfoTable('schienenguete')">
                        <cds-icon shape="info-standard" size="22" />
                      </a>
                    }
                  </td>
                </tr>
              </tbody>
            </table>

            <input
              type="file"
              #fileInputSHP
              id="fileInputSHP"
              accept=".dbf"
              name="fileInputSHP"
              style="display: none"
              (change)="onShpFileSelected($event)" />
            <br />
            <div class="btn-group">
              <button class="btn" (click)="startImportBVBStammden()" [disabled]="!isMappingValid()">
                {{ ' Stammdaten importieren' | mrTranslate }}
              </button>
              <button class="btn" (click)="saveImportBVBStammden()" [disabled]="!isMappingValid()">
                {{ 'Einstellungen speichern' | mrTranslate }}
              </button>
              <button class="btn" (click)="getImportBVBStammden()">
                <!-- [disabled]="!isMappingValid()"> -->
                {{ 'Einstellungen laden' | mrTranslate }}
              </button>
            </div>
          }
          @case ('moveStart') {
            <div class="flex-1-1-0 clr-align-self-stretch" style="min-height: 200px">
              <ng-container *ngTemplateOutlet="tableLeft" />
            </div>
            @let offset = moveGleisForm.value.offset;
            @let toDrehen = moveGleisForm.value.toDrehen;
            @let invalid = !toDrehen && !offset;
            <form
              id="move-gleis-form"
              class="form-box width100 no-margin clr-row nxm"
              clrForm
              autocomplete="off"
              [formGroup]="moveGleisForm"
              (ngSubmit)="moveGleisForm.valid && !invalid && startAction()"
              [clrLabelSize]="6"
              [clrLayout]="'horizontal'">
              <fieldset class="clr-col-6 nxp">
                <clr-input-container>
                  <label>{{ 'Startmeter alt' | mrTranslate }}</label>
                  <input
                    type="text"
                    clrInput
                    class="ellipsis"
                    readonly
                    [value]="+selectedtabellenL()?.startmeter | number: '.0-3'" />
                </clr-input-container>
                <clr-number-input-container>
                  <label class="clr-required-mark">{{ 'Startmeter neu' | mrTranslate }}</label>
                  <input type="number" clrNumberInput formControlName="startNeu" />
                  <clr-control-error *clrIfError="'required'">
                    {{ 'Erforderlich' | mrTranslate }}
                  </clr-control-error>
                  @if (moveGleisForm.controls.startNeu.errors?.min; as err) {
                    <clr-control-error>{{ 'Mindestens' | mrTranslate }} {{ err.min }}</clr-control-error>
                  }
                </clr-number-input-container>
              </fieldset>
              <fieldset class="clr-col-6 nxp">
                <clr-input-container>
                  <label>{{ 'Endmeter alt' | mrTranslate }}</label>
                  <input
                    type="text"
                    clrInput
                    class="ellipsis"
                    readonly
                    [value]="+selectedtabellenL()?.endmeter | number: '.0-3'" />
                </clr-input-container>
                <clr-input-container>
                  <label>{{ 'Endmeter neu' | mrTranslate }}</label>
                  <input type="text" clrInput formControlName="endNeu" readonly />
                  <clr-control-error *clrIfError="'required'">
                    {{ 'Erforderlich' | mrTranslate }}
                  </clr-control-error>
                  @if (moveGleisForm.controls.endNeu.errors?.min; as err) {
                    <clr-control-error>{{ 'Mindestens' | mrTranslate }} {{ err.min }}</clr-control-error>
                  }
                </clr-input-container>
              </fieldset>
              @if (moveGleisForm.valid) {
                <clr-alert
                  class="clr-col-12 nxp"
                  [clrAlertType]="invalid ? 'danger' : 'info'"
                  [clrAlertClosable]="false">
                  <clr-alert-item>
                    <span class="alert-text">
                      {{ 'Verschiebung' | mrTranslate }}
                      @if (toDrehen) {
                        &nbsp;{{ 'nach Drehen' | mrTranslate }}
                      }
                      : {{ offset }}
                    </span>
                  </clr-alert-item>
                </clr-alert>
              }
              <clr-toggle-container clrInline>
                <clr-toggle-wrapper>
                  <label>{{ 'absteigend' | mrTranslate }}</label>
                  <input type="checkbox" clrToggle formControlName="toDrehen" />
                </clr-toggle-wrapper>
              </clr-toggle-container>
            </form>
            <button type="submit" form="move-gleis-form" class="btn" [disabled]="!selectedtabellenL()">
              {{ 'Startposition versetzen' | mrTranslate }}
            </button>
          }
          @case ('lineConnect') {
            <div class="flex-1-1-0 clr-row clr-align-self-stretch" style="min-height: 200px">
              <div class="clr-col-6 h-100"><ng-container *ngTemplateOutlet="tableLeft" /></div>
              <div class="clr-col-6 h-100"><ng-container *ngTemplateOutlet="tableRight" /></div>
            </div>
            <button class="btn" (click)="startAction()" [disabled]="!(selectedtabellenL() && selectedtabellenR())">
              {{ 'Verbinden' | mrTranslate }}
            </button>
            <label>{{ info }}</label>
            <clr-progress-bar [clrValue]="pcnt" clrLabeled class="margin-10-t" style="max-width: 600px" />
          }
          @case ('lineCut') {
            <div class="flex-1-1-0 clr-align-self-stretch" style="min-height: 200px">
              <ng-container *ngTemplateOutlet="tableLeft" />
            </div>
            <form
              id="cut-gleis-form"
              class="form-box width100 no-margin"
              clrForm
              [formGroup]="cutGleisForm"
              (ngSubmit)="cutGleisForm.valid && startAction()"
              [clrLabelSize]="5"
              [clrLayout]="'horizontal'">
              @if (cutGleisForm.errors?.['start-vor-end']) {
                <clr-alert class="w-100-p" clrAlertType="danger" [clrAlertClosable]="false">
                  <clr-alert-item>
                    <span class="alert-text">
                      {{ 'Die neue Startposition ist kleiner als die Trennposition' | mrTranslate }}
                    </span>
                  </clr-alert-item>
                </clr-alert>
              }
              <fieldset formGroupName="cutL">
                <clr-number-input-container>
                  <label>{{ 'Trennposition (in m)' | mrTranslate }}</label>
                  <input type="number" clrNumberInput formControlName="Endposition" />
                  <clr-control-error *clrIfError="'required'">
                    {{ 'Erforderlich' | mrTranslate }}
                  </clr-control-error>
                  @let eP = cutGleisForm.get('cutL.Endposition');
                  @if (eP.errors?.min; as err) {
                    <clr-control-error>{{ 'Mindestens' | mrTranslate }} {{ err.min }}</clr-control-error>
                  }
                  @if (eP.errors?.max; as err) {
                    <clr-control-error>{{ 'Maximal' | mrTranslate }} {{ err.max }}</clr-control-error>
                  }
                </clr-number-input-container>
              </fieldset>
              <fieldset formGroupName="cutR">
                <clr-number-input-container>
                  <label>{{ 'Neue Startposition' | mrTranslate }}</label>
                  <input type="number" clrNumberInput formControlName="Startposition" />
                  <clr-control-error *clrIfError="'required'">
                    {{ 'Erforderlich' | mrTranslate }}
                  </clr-control-error>
                  @let sP = cutGleisForm.get('cutR.Startposition');
                  @if (sP.errors?.min; as err) {
                    <clr-control-error>{{ 'Mindestens' | mrTranslate }} {{ err.min }}</clr-control-error>
                  }
                  @if (sP.errors?.max; as err) {
                    <clr-control-error>{{ 'Maximal' | mrTranslate }} {{ err.max }}</clr-control-error>
                  }
                </clr-number-input-container>
                <clr-input-container>
                  <label>{{ 'Neuer Startpunkt' | mrTranslate }}</label>
                  <input type="text" clrInput formControlName="Startpunkt" />
                  <clr-control-error *clrIfError="'required'">
                    {{ 'Erforderlich' | mrTranslate }}
                  </clr-control-error>
                </clr-input-container>
                <clr-input-container>
                  <label>{{ 'Neue Bezeichnung' | mrTranslate }}</label>
                  <input type="text" clrInput formControlName="Bezeichnung" />
                  <clr-control-error *clrIfError="'required'">
                    {{ 'Erforderlich' | mrTranslate }}
                  </clr-control-error>
                </clr-input-container>
                <clr-input-container>
                  <label>{{ 'Neuer Messfile' | mrTranslate }}</label>
                  <input type="text" clrInput formControlName="Messfile" />
                  <clr-control-error *clrIfError="'required'">
                    {{ 'Erforderlich' | mrTranslate }}
                  </clr-control-error>
                </clr-input-container>
              </fieldset>
              <div class="form-box">
                <div class="clr-row nxm">
                  <fieldset class="clr-col-6 nxp">
                    @let cutL = cutGleisForm.value.cutL;
                    <clr-input-container>
                      <label>{{ 'Bezeichnung' | mrTranslate }}</label>
                      <input type="text" clrInput class="ellipsis" [value]="cutL.Bezeichnung" readonly />
                    </clr-input-container>
                    <clr-input-container>
                      <label>{{ 'Startpunkt' | mrTranslate }}</label>
                      <input type="text" clrInput class="ellipsis" [value]="cutL.Startpunkt" readonly />
                    </clr-input-container>
                    <clr-input-container>
                      <label>{{ 'Endpunkt' | mrTranslate }}</label>
                      <input type="text" clrInput class="ellipsis" [value]="cutL.Endpunkt" readonly />
                    </clr-input-container>
                    <clr-input-container>
                      <label>{{ 'Startposition' | mrTranslate }}</label>
                      <input type="text" clrInput class="ellipsis" [value]="cutL.Startposition" readonly />
                    </clr-input-container>
                    <clr-input-container>
                      <label>{{ 'Endposition' | mrTranslate }}</label>
                      <input type="text" clrInput class="ellipsis" [value]="cutL.Endposition" readonly />
                    </clr-input-container>
                    <clr-input-container>
                      <label>{{ 'Gleislänge' | mrTranslate }}</label>
                      <input type="text" clrInput class="ellipsis" [value]="cutL.Gleislaenge" readonly />
                    </clr-input-container>
                    <clr-input-container>
                      <label>{{ 'Messfile' | mrTranslate }}</label>
                      <input type="text" clrInput class="ellipsis" [value]="cutL.Messfile" readonly />
                    </clr-input-container>
                  </fieldset>
                  <fieldset class="clr-col-6 nxp">
                    @let cutR = cutGleisForm.value.cutR;
                    <clr-input-container>
                      <label>{{ 'Bezeichnung' | mrTranslate }}</label>
                      <input type="text" clrInput class="ellipsis" [value]="cutR.Bezeichnung" readonly />
                    </clr-input-container>
                    <clr-input-container>
                      <label>{{ 'Startpunkt' | mrTranslate }}</label>
                      <input type="text" clrInput class="ellipsis" [value]="cutR.Startpunkt" readonly />
                    </clr-input-container>
                    <clr-input-container>
                      <label>{{ 'Endpunkt' | mrTranslate }}</label>
                      <input type="text" clrInput class="ellipsis" [value]="cutR.Endpunkt" readonly />
                    </clr-input-container>
                    <clr-input-container>
                      <label>{{ 'Startposition' | mrTranslate }}</label>
                      <input type="text" clrInput class="ellipsis" [value]="cutR.Startposition" readonly />
                    </clr-input-container>
                    <clr-input-container>
                      <label>{{ 'Endposition' | mrTranslate }}</label>
                      <input type="text" clrInput class="ellipsis" [value]="cutR.Endposition" readonly />
                    </clr-input-container>
                    <clr-input-container>
                      <label>{{ 'Gleislänge' | mrTranslate }}</label>
                      <input type="text" clrInput class="ellipsis" [value]="cutR.Gleislaenge" readonly />
                    </clr-input-container>
                    <clr-input-container>
                      <label>{{ 'Messfile' | mrTranslate }}</label>
                      <input type="text" clrInput class="ellipsis" [value]="cutR.Messfile" readonly />
                    </clr-input-container>
                  </fieldset>
                </div>
              </div>
            </form>
            <button type="submit" form="cut-gleis-form" class="btn" [disabled]="!selectedtabellenL()">
              {{ 'Gleis trennen' | mrTranslate }}
            </button>
            <label>{{ info }}</label>
            <clr-progress-bar [clrValue]="pcnt" clrLabeled class="margin-10-t" style="max-width: 600px" />
          }
          @case ('lineTurn') {
            <div class="flex-1-1-0 clr-align-self-stretch" style="min-height: 200px">
              <ng-container *ngTemplateOutlet="tableLeft" />
            </div>
            <button class="btn" (click)="startAction()" [disabled]="!selectedtabellenL()">
              {{ 'Linie drehen' | mrTranslate }}
            </button>
          }
          @case ('checkLogs') {
            <div class="clr-row" style="justify-content: space-around">
              <clr-combobox-container>
                <label>{{ 'Datum' | mrTranslate }}</label>
                <clr-combobox name="cBox" (clrInputChange)="changeLogDate($event)">
                  <clr-options>
                    <clr-option *clrOptionItems="let logDate of logDates; field: 'value'" [clrValue]="logDate">
                      {{ logDate.name }}
                    </clr-option>
                  </clr-options>
                </clr-combobox>
              </clr-combobox-container>

              <div class="clr-control-container" style="width: 200px">
                <clr-password-container>
                  <label>Passwort</label>
                  <input
                    clrPassword
                    placeholder="{{ 'Passwort' | mrTranslate }}"
                    name="pw"
                    style="width: 200px"
                    [ngModel]="pw()"
                    (ngModelChange)="pw.set($event)" />
                  <clr-control-error *clrIfError="'required'">
                    {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                  </clr-control-error>
                </clr-password-container>
              </div>
            </div>
            <div
              class="clr-row"
              style="width: 85vw; height: 80vh; border: 1px solid black; padding: 15px; margin: 10px">
              <textarea clrTextarea [value]="bemerkung()" readonly class="h-100 w-100-p" rows="10"></textarea>
            </div>
          }
        }
        @if (action() | in: ['assignInsp', 'assignMess', 'assignError', 'sortOrder', 'kav_calculate', 'railshift']) {
          <label style="font-size: 20px">{{ trTitel() }}</label>
          @if (!taskRun) {
            <button class="btn btn-success" (click)="startAction()">
              {{ 'Starte Aktion' | mrTranslate }}
            </button>
          } @else {
            <button class="btn btn-danger" (click)="stopAction()">
              {{ 'Stop Aktion' | mrTranslate }}
            </button>
          }
          <label>{{ info }}</label>
          <clr-progress-bar [clrValue]="pcnt" clrLabeled class="margin-10-t" style="max-width: 600px" />
          @if (showInfo()) {
            <clr-textarea-container class="w-100-p flex-1-1-0 fill-space">
              <label>{{ 'Informationen' | mrTranslate }}</label>
              <textarea clrTextarea [value]="bemerkung()" readonly></textarea>
            </clr-textarea-container>
          }
        } @else if (
          action() | in: ['refreshDBConDictonary', 'deleteTestDatabase', 'deleteDevDatabase', 'redoCheckDatabase']
        ) {
          <label style="font-size: 20px">{{ trTitel() }}</label>
          <button class="btn btn-success" (click)="startAction()">{{ 'Starte Aktion' | mrTranslate }}</button>
        } @else if (action() | in: ['xlBauw', 'xlHerst']) {
          <label style="font-size: 20px">{{ trTitel() }}</label>
          <button class="btn btn-success" (click)="startAction()">{{ 'Starte Excel-Export' | mrTranslate }}</button>
        } @else if (action() | in: ['xlStammVorlageImp', 'xlStammEditImp', 'xlSpezEditImp']) {
          <label style="font-size: 20px">{{ trTitel() }}</label>
          <button class="btn btn-success" type="button" (click)="fileUpload.click()">
            <cds-icon shape="image-gallery" />
            {{ 'Datei einlesen' | mrTranslate }}
          </button>
          <input type="file" #fileUpload hidden (change)="startAction($event.target)" />
          <clr-progress-bar [clrValue]="pcnt" clrLabeled class="margin-10-t" style="max-width: 600px" />
          <clr-textarea-container class="w-100-p flex-1-1-0 fill-space">
            <label>{{ 'Informationen' | mrTranslate }}</label>
            <textarea clrTextarea [value]="bemerkung()" readonly></textarea>
          </clr-textarea-container>
        } @else if (action() | in: ['xlSpez', 'QRCode']) {
          <label style="font-size: 20px">{{ trTitel() }}</label>
          <div class="flex-1-1-0 scroll-y w-100-p d-f row clr-justify-content-center" style="min-height: 200px">
            <clr-tree class="clr-col-auto">
              @for (item of sotypListe(); track item.ID) {
                <clr-tree-node [(clrSelected)]="item.selected" [clrDisabled]="item.ANZAHL == 0">
                  <button class="clr-treenode-link" [class.active]="item.selected">
                    <cds-icon class="fill-black" [shape]="'objekttyp' + item.SysIcon" size="28" />
                    {{ item.BEZEICHNUNG }}
                  </button>
                </clr-tree-node>
              }
            </clr-tree>
          </div>
          @let Beschreibung =
            action() == 'xlSpez' ? 'Starte Excel-Export'
            : action() == 'QRCode' ? 'QR-Codes erstellen'
            : '';
          <button class="btn btn-success" (click)="startAction()">{{ Beschreibung | mrTranslate }}</button>
        } @else if (action() | in: ['xlStammVorlageExp', 'xlStammEditExp', 'xlSpezEditExp']) {
          <label style="font-size: 20px">{{ trTitel() }}</label>
          <clr-tree>
            @for (item of sotypListe(); track item.ID) {
              <clr-tree-node [clrDisabled]="item.ANZAHL == 0 && action() != 'xlStammVorlageExp'">
                <button class="clr-treenode-link" (click)="startAction(item)">
                  <cds-icon class="fill-black" [shape]="'objekttyp' + item.SysIcon" size="28" />
                  {{ item.BEZEICHNUNG }}
                </button>
              </clr-tree-node>
            }
          </clr-tree>
        }
      </div>
    </div>
  </div>

  <ng-template #centered>
      <div class="card centred" style="min-width: 500px">
        <div class="card-block progress-group">
          <div class="card-title">{{ 'Datensicherung erstellen' | mrTranslate }}</div>
          @if(isBackupStarted){
            <clr-checkbox-container>
              <label>{{'Datenbank' | mrTranslate }}</label>
                <clr-checkbox-wrapper>
                  <input type="checkbox" clrCheckbox
                    [checked]="selectedPaths.includes('Datenbank')"
                    (change)="onCheckboxChange('Datenbank', $event)"
                  />
                  <label>{{'Datenbank' | mrTranslate }}</label>
                </clr-checkbox-wrapper>         
            </clr-checkbox-container>

            <clr-checkbox-container>
              <label>{{'Ordner' | mrTranslate }}</label>
              @for (item of BackupFiles; track item.path) {
                <clr-checkbox-wrapper>
                  <input type="checkbox" clrCheckbox
                    [checked]="selectedPaths.includes(item.path)"
                    (change)="onCheckboxChange(item.path, $event)"
                  />
                  <label>{{item['path'] | mrTranslate}} {{'Dateien' | mrTranslate}}: {{item['count']}} [{{item['size']}} MB]</label>
                </clr-checkbox-wrapper>
              }
            </clr-checkbox-container>       
            <br/>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" (click)="runBackUpDB()" [disabled]="selectedPaths.length == 0">
                {{ 'OK' | mrTranslate }}
              </button>
              <button type="button" class="btn btn-primary" (click)="isDBBackup.set(false)">
                {{ 'Abbrechen' | mrTranslate }}
              </button>
            </div>
          }
          @else 
          {
            @let group = progressGroup();
            @if (group.status == 'idle') {
              <div class="centred" style="height: 90px"><clr-spinner /></div>
            } @else {
              @for (child of group.children | keyvalue: null; track child.key) {
                @let progress = child.value;
                <div class="progress-block">
                  @if (progress.title) {
                    <label style="min-width: 100px" for="{{ child.key }}">{{ progress.title | mrTranslate }}</label>
                  }
                  @if (progress.error) {
                    <div class="flex-1-1-auto invalid-red margin-6-l">{{ progress.error }}</div>
                  } @else if (progress.info) {
                    <div class="flex-1-1-auto margin-6-l">{{ progress.info }}</div>
                  } @else {
                    <clr-progress-bar
                      class="centeredprogress"
                      id="{{ child.key }}"
                      clrColor="success"
                      [clrValue]="progress.percent ?? progress.current"
                      [clrDisplayval]="progress.percent == null ? `${progress.current}` : ''"
                      [clrLabeled]="!progress.total"
                      [clrLoop]="progress.percent == null" />
                    @if (progress.total) {
                      <span class="margin-6-l">{{ progress.current ?? 0 }} / {{ progress.total }}</span>
                    }
                  }
                </div>
              }
            }
            @if(isBackupFinished){
              <div class="margin-6-t margin-12-b">
                {{ '✅' }} {{ 'Datenbanksicherung wurde erfolgreich abgeschlossen.' | mrTranslate }}
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="isDBBackup.set(false)">
                  {{ 'OK' | mrTranslate }}
                </button>
              </div>
            }
          }
        </div>
      </div>
    
  </ng-template>

  <ng-template #tableLeft>
    @if (tblLeft(); as table) {
      <clr-datagrid
        class="h-100 datagrid-compact"
        [clrDgSelectionType]="'single'"
        [clrDgSelected]="[selectedtabellenL()]"
        (clrDgSelectedChange)="selectedtabellenL.set($event[0])"
        [clrDgItemsIdentityFn]="row => row?.[trackByKey()]">
        @for (column of table.columns; track column) {
          <clr-dg-column [clrDgField]="column.id">
            <clr-dg-filter>
              <app-column-filter
                #left
                [column]="column"
                [objektTypIconValue]="filterStore.iconMap()"
                [uniqueColumnValues]="filterStore.uniqueValues()[column.id]"
                (changes)="filterStore.onChange($event)" />
            </clr-dg-filter>
            <ng-container
              *clrDgHideableColumn="{
                hidden: column.id | hideIDColumns: ['bildpfad', 'lf', 'st', 'sp', 'messreg bezirk'],
              }">
              {{ column.id | titlecase | mrTranslate }}
            </ng-container>
          </clr-dg-column>
        }
        <ng-template
          clrVirtualScroll
          let-row
          [clrVirtualRowsOf]="filterStore.filteredRows()"
          [clrVirtualRowsTrackBy]="(_, row) => row?.[trackByKey()]">
          <clr-dg-row [clrDgItem]="row">
            @for (cell of table.columns; track cell.id) {
              <clr-dg-cell><app-icon-dg-cell [column]="cell" [row]="row" /></clr-dg-cell>
            }
          </clr-dg-row>
        </ng-template>
        <clr-dg-footer>{{ filterStore.filteredRows().length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
      </clr-datagrid>
    } @else {
      <clr-spinner class="centred" />
    }
  </ng-template>

  <ng-template #tableRight>
    @if (tblRight(); as table) {
      <clr-datagrid
        class="h-100 datagrid-compact"
        [clrDgSelectionType]="'single'"
        [clrDgSelected]="[selectedtabellenR()]"
        (clrDgSelectedChange)="selectedtabellenR.set($event[0])"
        [clrDgItemsIdentityFn]="row => row?.[trackByKey()]">
        @for (column of table.columns; track column) {
          <clr-dg-column [clrDgField]="column.id">
            <clr-dg-filter>
              <app-column-filter
                #right
                [column]="column"
                [objektTypIconValue]="filterStore_II.iconMap()"
                [uniqueColumnValues]="filterStore_II.uniqueValues()[column.id]"
                (changes)="filterStore_II.onChange($event)" />
            </clr-dg-filter>
            <ng-container
              *clrDgHideableColumn="{
                hidden: column.id | hideIDColumns: ['bildpfad', 'lf', 'st', 'sp', 'messreg bezirk'],
              }">
              {{ column.id | titlecase | mrTranslate }}
            </ng-container>
          </clr-dg-column>
        }
        <ng-template
          clrVirtualScroll
          let-row
          [clrVirtualRowsOf]="filterStore_II.filteredRows()"
          [clrVirtualRowsTrackBy]="(_, row) => row?.[trackByKey()]">
          <clr-dg-row [clrDgItem]="row">
            @for (cell of table.columns; track cell.id) {
              <clr-dg-cell><app-icon-dg-cell [column]="cell" [row]="row" /></clr-dg-cell>
            }
          </clr-dg-row>
        </ng-template>
        <clr-dg-footer>{{ filterStore_II.filteredRows().length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
      </clr-datagrid>
    } @else {
      <clr-spinner class="centred" />
    }
  </ng-template>

  <ng-template #tableLeftMulti>
    @if (tblLeft(); as table) {
      <clr-datagrid
        class="h-100 datagrid-compact"
        [clrDgSelectionType]="'multi'"
        [clrDgSelected]="selectedtabellenLM()"
        (clrDgSelectedChange)="selectedtabellenLM.set($event)"
        [clrDgItemsIdentityFn]="row => row?.[trackByKey()]">
        @for (column of table.columns; track column) {
          <clr-dg-column [clrDgField]="column.id">
            <clr-dg-filter>
              <app-column-filter
                #left
                [column]="column"
                [objektTypIconValue]="filterStore.iconMap()"
                [uniqueColumnValues]="filterStore.uniqueValues()[column.id]"
                (changes)="filterStore.onChange($event)" />
            </clr-dg-filter>
            <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['bildpfad'] }">
              {{ column.id | titlecase | mrTranslate }}
            </ng-container>
          </clr-dg-column>
        }
        <ng-template
          clrVirtualScroll
          let-row
          [clrVirtualRowsOf]="filterStore.filteredRows()"
          [clrVirtualRowsTrackBy]="(_, row) => row?.[trackByKey()]">
          <clr-dg-row [clrDgItem]="row">
            @for (cell of table.columns; track cell.id) {
              <clr-dg-cell><app-icon-dg-cell [column]="cell" [row]="row" /></clr-dg-cell>
            }
          </clr-dg-row>
        </ng-template>
        <clr-dg-footer>{{ filterStore.filteredRows().length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
      </clr-datagrid>
    } @else {
      <clr-spinner class="centred" />
    }
  </ng-template>

  @if (showdetailview) {
    <div #dvwrapper id="wrapperdetailview" [class]="{ sidenavenlarged, hidedetailview, split50 }">
      <app-detailview
        #detailView
        [ostammid]="_ostammid"
        [viewMode]="1"
        [expanded]="sidenavenlarged"
        [hidden]="hidedetailview"
        (enlarge)="enlargeSidenav($event)" />
    </div>
  }
</div>

<clr-modal [(clrModalOpen)]="showModalTable" [clrModalClosable]="true" [clrModalSize]="'xl'">
  <h3 class="modal-title">{{ showModalTitle() | mrTranslate }}</h3>
  <div class="modal-body">
    @if (curtable()) {
      <table class="table table-compact">
        <thead>
          <tr>
            @for (col of curtable()?.columns ?? []; track col) {
              <th>{{ col }}</th>
            }
          </tr>
        </thead>

        <tbody>
          @for (row of curtable()?.rows ?? []; track $index) {
            <tr>
              @for (col of curtable()?.columns ?? []; track col) {
                <td>{{ row[col] }}</td>
              }
            </tr>
          }
        </tbody>
      </table>
    }
  </div>

  <div class="modal-footer">
    <button type="button" class="btn" (click)="showModalTable = false">OK</button>
  </div>
</clr-modal>

<clr-modal [(clrModalOpen)]="showCreateTestDatabase" [clrModalClosable]="true" [clrModalSize]="'xl'">
  <h3 class="modal-title">{{ devDatabase + ' erstellen' | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm clrLayout="vertical">
      <div class="clr-row">
        <div class="clr-col-1">
          <app-all-selected-btn class="btn-sm nm" [(selected)]="selectedUsers" [all]="users?.rows ?? []" />
        </div>
        <div class="clr-col-11">
          <span>
            {{ `Bitte wählen Sie die Benutzer aus, die Zugriff auf die ${devDatabase} erhalten sollen.` | mrTranslate }}
          </span>
        </div>
      </div>

      @if (users?.columns) {
        <div style="height: 60vh">
          <clr-datagrid
            class="datagrid-compact h-100"
            [clrDgSelectionType]="'multi'"
            [(clrDgSelected)]="selectedUsers"
            [clrDgItemsIdentityFn]="row => row?.id"
            [clrDgRowSelection]="true">
            @for (column of users.columns; track column) {
              <clr-dg-column [clrDgField]="column.id">
                <ng-container
                  *clrDgHideableColumn="{
                    hidden:
                      column.id
                      | hideIDColumns
                        : [
                            'userimagebase64',
                            'eisenbahnbetriebsleiter (ebl)',
                            'anlagenverantwortlicher (alv)',
                            'user_ebl',
                            'user_alv',
                            'status',
                            'pwhash',
                            'kprolid',
                          ],
                  }">
                  {{ column.id | titlecase | mrTranslate }}
                </ng-container>
              </clr-dg-column>
            }
            <ng-template
              clrVirtualScroll
              let-row
              [clrVirtualRowsOf]="users.rows"
              [clrVirtualRowsTrackBy]="(_, row) => row?.id">
              <clr-dg-row [clrDgItem]="row">
                @for (cell of users.columns; track cell.id) {
                  <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                }
              </clr-dg-row>
            </ng-template>
            <clr-dg-footer>{{ users.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
          </clr-datagrid>
        </div>
      }
      <div class="clr-row">
        @if (doCreateTestDatabase) {
          <div class="clr-col-12">
            <clr-progress-bar [clrValue]="pcnt" clrLabeled style="margin-top: 10px; max-width: 85vw"></clr-progress-bar>
          </div>
        }
      </div>

      <div class="clr-row">
        @if (doCreateTestDatabase) {
          <div class="clr-col-12">
            <span style="margin-top: 10px">{{ text }}</span>
          </div>
        }
      </div>
    </form>
  </div>
  @if (!doCreateTestDatabase) {
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-primary"
        (click)="createTestDatabase()"
        [disabled]="selectedUsers.length == 0">
        OK
      </button>
      <button type="button" class="btn" (click)="showCreateTestDatabase = false">{{ 'Abbrechen' | mrTranslate }}</button>
    </div>
  }
</clr-modal>
